/**
 * 	i18nについて
 * 
 * 	- メッセージの作成方法
 * 		src/assets/messages以下に~~~Msg.jsonというファイルを作成する。
 * 
 * 		※注意
 * 			- 共通メッセージは「commonMsg.json」に、画面別は「[screenName]Msg.json」に記載する。
 * 			- メッセージの書き方は他のメッセージファイルを参照ください。
 * 			- messagesディレクトリ以下にあるjsonファイルは自動で読み込まれます。(../conf/i18nMsgを参照)
 * 
 * 	- 使用方法
 * 		script側での利用
 * 		alert(this.$i18n.tc('errMsg.session'));
 * 
 * 		テンプレート側での利用
 * 		<h4 v-text="$t('yubikeyMsg.table.title')"></h4>
 * 
 * 		commonMsg.jsonに記述したものは、key.messageで呼び出せる。
 * 		その他のjsonに記述したものは、jsonファイル名(拡張子除く).key.messageで呼び出せる。
*/
//import Vue from 'vue'
import { createI18n } from 'vue-i18n'
//Vue.use(VueI18n)

// メッセージ定義の取得
import { getCombinedMessages } from './i18nMsg'
const messages = getCombinedMessages();

// 言語設定設定
import multilingual from '../script/multilingual';
import cookieUtil from '../script/cookieUtil';

// Cookieから言語設定を取得
let language = cookieUtil.getCookieInfoByKey('i18n_redirected');
if(!language || (language != "en" && language != "ja")){
	// ブラウザの言語設定を使用
	language = multilingual.getBrowserLanguage();
}

// ロケールとメッセージ設定
const i18n = createI18n({
	legacy: false,
	locale: language,
	messages: messages,
	warnHtmlMessage: false,
})

export { i18n }